<script lang="ts" setup>
const listType = inject('listType', 'ul')
</script>

<template>
  <li>
    <span
      v-if="listType === 'ul'"
      class="richtext__usp-icon"
    >
      <NuxtIcon
        name="icon:check"
      />
    </span>
    <slot />
  </li>
</template>
